import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { FeatureSwitchName } from 'app/projects/shared/src/lib/enums/feature-switch.enum';
import { FeatureSwitchPipe } from 'app/projects/shared/src/lib/pipes/feature-switch.pipe';
import { UserState } from 'app/projects/user/src/lib/models/user.state';
import { Observable, of } from 'rxjs';
import { FetchUserProgress, FetchUserProgressFailure, FetchUserProgressSuccess } from '../actions';

@Injectable()
export class UserProgressResolver  {
    constructor(private _store: Store, private _actionHelper: NgxsActionHelper, private _featureSwitchPipe: FeatureSwitchPipe) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const isTeamsFeatureEnabled = this._featureSwitchPipe.transform(FeatureSwitchName.Teams);
        if (isTeamsFeatureEnabled) {
            const userId = route.params['userId'] || this._store.selectSnapshot(UserState.getMyInfo).id;

            this._store.dispatch(new FetchUserProgress(userId));

            return this._actionHelper.race(FetchUserProgressSuccess, FetchUserProgressFailure);
        } else {
            return of(true);
        }
    }
}
